import FilesList from 'components/v2/file-row/FilesList';
import FileUpload from 'components/v2/file-upload/FileUpload';
import { HelpBox } from 'components/v2/help-boxes';
import { ButtonUploadIcon } from 'components/v2/icons';
import { EPD_DEVELOPMENT_VERIFICATION_TEMPLATES_URL } from 'constants/constants';
import { Dialog } from 'primereact/dialog';
import { ChangeEvent } from 'react';
import { EPDModel, FileLoadingModel } from 'services/EpdClient';
import styled from 'styled-components';
import { HyperLink } from 'styles/Styles.styled';

type TProps = {
  epd?: EPDModel;
  isOpened: boolean;
  header: string;
  onHide: any;
  onUploadFile(field: string, file: File): void;
  onRemoveFile(fileId: string): void;
  fileLoading?: FileLoadingModel[];
};

const UploadVerificationReportDialog = ({ isOpened, onHide, epd, onUploadFile, onRemoveFile, fileLoading }: TProps) => {
  const uploadFile = async (e: ChangeEvent<HTMLInputElement>, propertyName: string) => {
    const target = e.target as HTMLInputElement;
    let file = target && target.files && target.files[0];
    if (!file || !epd) {
      return null;
    }

    onUploadFile(propertyName, file);
  };
  return (
    <>
      <Dialog header="Upload documents" visible={isOpened} style={{ width: '50vw' }} onHide={onHide} footer={null}>
        <DialogContentContainer>
          <HelpBox>
            <span>
              Please upload the verification report in either DOCX, PDF, or XLSX format using the{' '}
              <HyperLink href={EPD_DEVELOPMENT_VERIFICATION_TEMPLATES_URL} target="_blank">
                provided template
              </HyperLink>
              .<br />
              Multiple reports can be uploaded if necessary.
            </span>
          </HelpBox>
          <FileUpload
            label="Upload document"
            name="VerificationReport"
            icon={ButtonUploadIcon}
            accept=".pdf,.docx,.xlsx"
            validExtensions={['pdf', 'docx', 'xlsx']}
            onFileUpload={uploadFile}
          />
          <FilesList
            files={epd?.verificationReports}
            onRemoveFile={onRemoveFile}
            fileLoading={
              fileLoading?.find((loading) => loading.fileType === 'VerificationReport' && loading.loadingsCount > 0) !==
              undefined
            }
          />
        </DialogContentContainer>
      </Dialog>
    </>
  );
};

const DialogContentContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  overflow-y: auto;
`;
export default UploadVerificationReportDialog;
